import { MeasurementUnitEnum } from 'domains/measurementDomain';
import { Organization } from 'domains/orgDomain';
import {
  CarrierServiceSelects,
  JobConfigGenerateTypeEnum,
  JobGenerateTypeEnum,
  QtyItemRequirement,
  RFQOrgStatusEnum,
  RFQStatusEnum,
  ShippingAccountTypeEnum,
} from './jobconfigDomain';
import {
  BillingInfo,
  BillingRequestor,
  CostDistributionPayload,
  OrderHistorySearchGroupEnum,
  ShipmentTypeEnum,
} from './orderDomain';
import { UserContactAddress } from './orgDomain';
import { SiteRoleEnum } from './roleDomain';
import { CarrierTypeEnum } from './shippingDomain';
import { ArtworkOptionEnum, InkEnum } from './skuDomain';
import { ShippingInfo } from './workspaceDetailDomain';

export type PaperSize = {
  width: number;
  height: number;
};

export enum JobUIStatusEnum {
  SAVE_QUOTES = 'SAVE_QUOTES',
  NEED_ARTWORK = 'NEED_ARTWORK',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  PROOFING = 'PROOFING',
  PENDING_PO = 'PENDING_PO',
  RFM = 'RFM',
  IN_PRODUCTION = 'IN_PRODUCTION',
  SHIPPED = 'SHIPPED',
  SHIPPING = 'SHIPPING',
  BILLING = 'BILLING',
  INVOICING = 'INVOICING',
  PAY_INVOICE = 'PAY_INVOICE',
  SEPARATOR = 'SEPARATOR',
  RFQ = 'RFQ',
}

export type JobStatusFilterCount = {
  count: number;
  jobStatusFilter: JobUIStatusEnum;
  separateTabs: SeparateTabs[];
};

export interface SeparateTabs {
  separateTab: JobStatusFilterSeparateTabEnum;
  count: number;
}

export enum JobWorkflowStatusEnum {
  QUOTE = 'QUOTE',
  IN_CART = 'IN_CART',
  ORDERING = 'ORDERING',
  PO_SENT = 'PO_SENT',
  PO_READ = 'PO_READ',
  RFM_NEEDED = 'RFM_NEEDED',
  PO_DECLINED = 'PO_DECLINED',
  PO_ACCEPT = 'PO_ACCEPT',
  RFM = 'RFM',
  RFQ = 'RFQ',
  PREPARE_PROOF = 'PREPARE_PROOF',
  PROOF_AWAIT_APPROVAL = 'PROOF_AWAIT_APPROVAL',
  PROOF_NEED_REVISION = 'PROOF_NEED_REVISION',
  IN_PRODUCTION = 'IN_PRODUCTION',
  SHIPPED = 'SHIPPED',
  DELIVERED = 'DELIVERED',
  INVOICING = 'INVOICING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum JobWorkflowStatusFilterOutsourceEnum {
  PO_SENT = 'PO_SENT',
  PO_READ = 'PO_READ',
  RFM_NEEDED = 'RFM_NEEDED',
  PO_DECLINED = 'PO_DECLINED',
  PO_ACCEPT = 'PO_ACCEPT',
  RFM = 'RFM',
  RFQ = 'RFQ',
  PREPARE_PROOF = 'PREPARE_PROOF',
  PROOF_AWAIT_APPROVAL = 'PROOF_AWAIT_APPROVAL',
  PROOF_NEED_REVISION = 'PROOF_NEED_REVISION',
  IN_PRODUCTION = 'IN_PRODUCTION',
  SHIPPED = 'SHIPPED',
  DELIVERED = 'DELIVERED',
  INVOICING = 'INVOICING',
}

export enum JobSubStatusEnum {
  awaitArt = 'awaitArt',
  awaitProof = 'awaitProof',
  awaitApprove = 'awaitApprove',
  awaitCustomerApprove = 'awaitCustomerApprove',
  awaitSupplierResponse = 'awaitSupplierResponse',
  awaitSupplierJobClaim = 'awaitSupplierJobClaim',
  awaitSupplierProof = 'awaitSupplierProof',
  prepareProof = 'prepareProof',
  reviseProof = 'reviseProof',
  rfmNeeded = 'rfmNeeded',
  needFasterShipDate = 'needFasterShipDate',
  paymentRequested = 'paymentRequested',
  revshopJob = 'revshopJob',
  outsourceJob = 'outsourceJob',
  internalJob = 'internalJob',
  poDeclined = 'poDeclined',
  none = 'none',
  missingArtwork = 'missingArtwork',
  needArtNow = 'needArtNow',
  jobAdjustmentInProgress = 'jobAdjustmentInProgress',
  jobAdjustmentAccepted = 'jobAdjustmentAccepted',
  completed = 'completed',
  closed = 'closed',
}

export enum RFQJobLabelStatusEnum {
  identifyingSupplier = 'identifyingSupplier',
  rfqsSentToSuppliers = 'rfqsSentToSuppliers',
  completed = 'completed',
  closed = 'closed',
}

export enum FilterTabEnum {
  SUMMARY = 'Summary',
  PROOFS = 'PROOFS',
  FILES = 'FILES',
  RFM = 'RFM',
  NOTES = 'NOTES',
  ACTIVITY = 'ACTIVITY',
  SHIPPING_BILLING = 'SHIPPING_BILLING',
  INVOICING = 'INVOICING',
  MORE_ACTIONS = 'MORE',
  RFQ = 'RFQ',
}

export enum JobSupplierTypeEnum {
  REVSHOP = 'REVSHOP',
  INTERNAL = 'INTERNAL',
}

export interface JobCardShippingItem {
  actualDeliveryTime: string;
  actualShipTime: string;
  carrierService: string;
  carrierType: CarrierTypeEnum;
  estimatedDeliveryTime: string;
  estimatedShipTime: string;
  fulfillmentId: number;
  quantity: number;
  trackingCode: string;
  shippingDetail: string;
}

export enum PaperOrientationEnum {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
  CUBE = 'CUBE',
}

export enum JobTypeEnum {
  INTERNAL = 'INTERNAL',
  NETWORK = 'NETWORK',
  OUTSOURCE = 'OUTSOURCE',
}

export enum JobParticipantEnum {
  CUSTOMER = 'CUSTOMER',
  OPERATOR = 'OPERATOR',
  PRODUCER = 'PRODUCER',
  PROXY = 'PROXY',
}

export type JobPoData = {
  sentTime: string;
  expireTime: string;
  price: number;
};

export enum InvoiceStatusEnum {
  APPLIED = 'APPLIED',
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  MARK_AS_PAID = 'MARK_AS_PAID',
  FAILED = 'FAILED',
}

export enum JobAdjustmentStatusEnum {
  NONE = 'NONE',
  EDITING = 'EDITING',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  AWAITING_ACCEPT = 'AWAITING_ACCEPT',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}

export enum JobCancellationStatusEnum {
  NONE = 'NONE',
  IN_PROGRESS = 'IN_PROGRESS',
  JOB_CANCELED = 'JOB_CANCELED',
}

export type JobItem = {
  artworkConfirm: boolean;
  artworkOption: ArtworkOptionEnum;
  chargeOrgId: number;
  chargeOrgName: string | null;
  customerFullName: string;
  customerId: number;
  customerOrgId: number;
  customerOrgName: string;
  id: number;
  quoteId: string;
  isQuote: boolean;
  orderId: string;
  insidePageNum: number;
  jobCardShippingItems: JobCardShippingItem[];
  jobCharge: number;
  jobType: JobTypeEnum;
  tax: number;
  participants: JobParticipantEnum[];
  name: string;
  orientation: PaperOrientationEnum;
  quantity: number;
  quantityItems: QuantityItem[];
  size: string;
  /** Metric twin of `size`, sent alongside so a unit switch needs no refetch. */
  sizeMetric?: string;
  /**
   * The ready-made size this job was configured with, e.g. `A4`.
   *
   * Shown instead of the dimensions, but only to a buyer working in `sizePresetUnit`. Null for a
   * size the supplier typed, and for jobs placed before this existed.
   */
  sizePreset?: string;
  sizePresetUnit?: MeasurementUnitEnum;
  skuId: number;
  skuName: string;
  skuTypeId: number;
  skuTypeName: string;
  supplierPrintingCharge: number;
  supplierFreightCharge: number;
  supplierCharge: number;
  supplierOrgId: number;
  supplierOrgName: string | null;
  allShipped: boolean;
  workflowStatus: JobWorkflowStatusEnum;
  workspaceType: JobWorkflowStatusEnum;
  wrapperSpecId: number;
  jobPo: JobPoData;
  notesCount: number;
  filesCount: number;
  activityCount: number;
  proofsCount: number;
  jobContacts?: JobCardContacts;
  jobSharedWiths?: JobSharedWith[];
  jobActivitiesCount?: number;
  jobNotesCount?: number;
  hasRfm: boolean;
  invoiceStatus: InvoiceStatusEnum;
  updateAt?: string;
  createAt?: string;
  priceGuaranteeHours?: number;
  image?: string;
  billingRequestor: BillingRequestor;
  billingInfo: BillingInfo;
  // the single oracle billing code to show, absent when there is none or when there is more than one
  oracleBillingCode?: string;
  // true when the cost distribution splits into more than one code, link to Shipping & Billing instead
  multipleOracleBillingCode?: boolean;
  rfqStatus?: RFQStatusEnum;
  qtyItemRequirements?: QtyItemRequirement[];
  generateType?: JobGenerateTypeEnum;
  configGenerateType?: JobConfigGenerateTypeEnum;
  jobGenerateType?: JobGenerateTypeEnum;
  jobConfigGenerateType?: JobConfigGenerateTypeEnum;
  canAddToCart: boolean;
  isProxied: boolean;
  canEdit: boolean;
  rush: boolean;
  digitalProofRequired: boolean;
  hardcopyProofRequired: boolean;
  adjustmentStatus: JobAdjustmentStatusEnum;
  cancellationStatus: JobCancellationStatusEnum;
  expectPaymentBy: string;
  skipArtFile: boolean;
  revisionJobId: string;
  activeTab?: FilterTabEnum;
  ticketDownloaded: boolean | null;
  statusChangeAt: string;
  invoice: JobInvoice;
  archived: boolean;
  directlyAddToCart: boolean;
  jobFilesEditable: boolean;
  statusFilters: JobUIStatusEnum[];
  projectId: number;
  projectName: string;
  sendInvoiceFileUrl: string;
  sendQuickBooksInvoiceFileUrl: string;
  invoiceExpired?: boolean;
  quickBooksInvoiceExpired?: boolean;
  receiveInvoiceFileUrl: string;
  receiveQuickBooksInvoiceFileUrl: string;
  shareList?: JobInvoiceShare[];
  invoiceNumber?: string;
  jobCustomerOrgInfoDTO?: JobCustomerOrgInfoDTO;
  batchUploadInvoiceNumber: string;
  copyFromId: number | null;
  canCopyRfq: boolean | null;
  manualOverrideReadyDate: boolean | null;
};

export  type RFQCopyRequestDTO = {
  rfqId: number;
}

export type RFQCopyResponseDTO = {
  newRfqId: number;
}

export type JobInvoiceShare = {
  firstName: string;
  lastName: string;
  email: string;
  expired?: boolean;
};

export interface JobInvoice {
  // supplierInvoiceFile: JobInvoiceSupplierFile;
  supplierInvoiceReferenceFiles: JobInvoiceSupplierFile[];
  supplierInvoiceNumber: string;
  supplierInvoiceNumberAttached: boolean;
  invoiceAt: string;
  markAsPaidTime: string;
}

export interface JobInvoiceSupplierFile {
  name: string;
  path: string;
}

export interface JobOriginalQuote {
  id: number;
  revxCharge: number;
  supplierCharge: number;
  revxFreightCharge: number;
}

export interface ShippingItems {
  carrierService: string;
  deliveryDate: string;
  serialNumber: number;
}

export interface QuantityItem {
  serialNumber: number;
  quantity: number;
  price: number;
  printingPrice: number;
}

export interface JobSharedWith {
  firstName: string;
  lastName: string;
  email: string;
}

export interface JobCardContacts {
  /** Null when the customer has no default contact - the API resolves it with a map lookup. */
  createBy: UserContactAddress | null;
  customerOrg: JobCardOrg;
  revshopContacts: UserContactAddress[];
  supplierContacts: UserContactAddress[];
  supplierOrg: JobCardOrg;
  revshopContactsLabel: string;
}

export interface JobCardOrg {
  orgId: number;
  orgName: string;
}

export type JobCount = {
  allShipped: boolean;
  filesCount: number;
  hasRfm: boolean;
  jobActivitiesCount: number;
  jobId: number | string;
  jobNotesCount: number;
  proofsCount: number;
};

export type JobItemShipped = {
  jobId: number;
  allShipped: boolean;
};

export interface AddInvoiceSharedParam {
  jobId: string | number;
  email: string;
  firstName: string;
  lastName: string;
  invoiceFileUrl?: string;
  quickBooksInvoiceUrl?: string;
}

export type OrderLineItemAddress = {
  id: number;
  address1: string;
  address2: string;
  city: string;
  company: string;
  country: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  province: string;
  zip: string;
};

export type TaxItem = {
  price: number;
  rate: number;
  title: string;
};

export type OrderLineItem = {
  id: number;
  name: string;
  quantity: number;
  destination: OrderLineItemAddress;
  total_shipping_price: number;
  sub_total: number;
  total: number;
  tax_lines: TaxItem[];
};

export enum ShipmentStatusEnum {
  Shipped = 'Shipped',
}

export type Fulfillment = {
  id: number;
  order_id: number;
  line_items: OrderLineItem[];
  tracking_company: string;
  shipment_status: ShipmentStatusEnum;
  tracking_numbers: string[];
  tracking_urls: string[];
};

export const SOURCER_JOB_STATUS_COLLECTION = [
  JobUIStatusEnum.SAVE_QUOTES,
  JobUIStatusEnum.RFM,
  JobUIStatusEnum.RFQ,
  JobUIStatusEnum.SEPARATOR,
  JobUIStatusEnum.NEED_ARTWORK,
  JobUIStatusEnum.PROOFING,
  JobUIStatusEnum.PENDING_PO,
  JobUIStatusEnum.IN_PRODUCTION,
  JobUIStatusEnum.SHIPPING,
  JobUIStatusEnum.INVOICING,
];

export const SUPPLIER_JOB_STATUS_COLLECTION = [
  JobUIStatusEnum.SAVE_QUOTES,
  JobUIStatusEnum.RFM,
  JobUIStatusEnum.RFQ,
  JobUIStatusEnum.SEPARATOR,
  JobUIStatusEnum.NEED_ARTWORK,
  JobUIStatusEnum.PROOFING,
  JobUIStatusEnum.PURCHASE_ORDER,
  JobUIStatusEnum.IN_PRODUCTION,
  JobUIStatusEnum.SHIPPING,
  JobUIStatusEnum.BILLING,
  JobUIStatusEnum.INVOICING,
];

export const SUPPLIER_REVSHOP_JOB_STATUS_COLLECTION = [
  JobUIStatusEnum.SAVE_QUOTES,
  JobUIStatusEnum.RFM,
  JobUIStatusEnum.RFQ,
  JobUIStatusEnum.SEPARATOR,
  JobUIStatusEnum.PURCHASE_ORDER,
  JobUIStatusEnum.NEED_ARTWORK,
  JobUIStatusEnum.PROOFING,
  JobUIStatusEnum.IN_PRODUCTION,
  JobUIStatusEnum.SHIPPING,
  JobUIStatusEnum.BILLING,
  JobUIStatusEnum.INVOICING,
];

export const SUPPLIER_INTERNAL_JOB_STATUS_COLLECTION = [
  JobUIStatusEnum.SAVE_QUOTES,
  JobUIStatusEnum.SEPARATOR,
  JobUIStatusEnum.NEED_ARTWORK,
  JobUIStatusEnum.PROOFING,
  JobUIStatusEnum.IN_PRODUCTION,
  JobUIStatusEnum.SHIPPING,
  JobUIStatusEnum.BILLING,
  JobUIStatusEnum.INVOICING,
];

export const SUPPLIER_JOB_STATUS_NOT_IN_NETWORK_COLLECTION = [
  JobUIStatusEnum.SAVE_QUOTES,
  JobUIStatusEnum.SEPARATOR,
  JobUIStatusEnum.NEED_ARTWORK,
  JobUIStatusEnum.PROOFING,
  JobUIStatusEnum.IN_PRODUCTION,
  JobUIStatusEnum.SHIPPING,
  JobUIStatusEnum.BILLING,
  JobUIStatusEnum.INVOICING,
];

export const BUYER_JOB_STATUS_COLLECTION = [
  JobUIStatusEnum.SAVE_QUOTES,
  JobUIStatusEnum.SEPARATOR,
  JobUIStatusEnum.NEED_ARTWORK,
  JobUIStatusEnum.PROOFING,
  JobUIStatusEnum.IN_PRODUCTION,
  JobUIStatusEnum.SHIPPED,
];

export const RoleJobStatusCollectionMap: {
  [index: string]: JobUIStatusEnum[];
} = {
  [SiteRoleEnum.Sourcer]: SOURCER_JOB_STATUS_COLLECTION,
  [SiteRoleEnum.Supplier]: SUPPLIER_INTERNAL_JOB_STATUS_COLLECTION,
  [SiteRoleEnum.Buyer]: BUYER_JOB_STATUS_COLLECTION,
  [JobTypeEnum.NETWORK]: SUPPLIER_REVSHOP_JOB_STATUS_COLLECTION,
};

export interface RFMOffer {
  id: number | undefined;
  jobId: number;
  round: number;
  turnTimeDays: number;
  expireAt: string;
  alertSourcerTime: string;
  buyerPrice: number;
  shippingPrice: number;
  revshopShippingPrice: number | null;
  supplierPrice: number;
  revshopMargin: number;
  pressAdjustments: PressAdjustment[] | null;
  shippingAdjustments: ShippingAdjustment[] | null;
  invitations: RFMInvitation[];
  createAt: string;
  jobShipDate: string | null;
  jobShippingMethod: string | null;
  /** revshop's markup on freight it puts on its own account, as a percentage */
  shippingMarkupPct: number | null;
  /** account the job's freight sits on, for rounds carrying no shipping of their own */
  jobShippingAccountType: ShippingAccountTypeEnum | null;
  jobShippingAccount: string | null;
  originalPoPrice: number | null;
  originalPoId: number | null;
  cancelled: boolean | null;
  cancelledAt: string | null;
  cancelledByUserId: number | null;
  cancellationReason: string | null;
}

export interface RFMOfferUI extends RFMOffer {
  /** buyer price the round started from, so edits are re-derived rather than compounded */
  buyerPriceBase?: number;
  expireAtFormatted: string;
}

export interface JobRFM {
  job: JobItem;
  rfm: RFMOffer;
}

export interface PressAdjustment {
  skuId: number;
  skuName: string;
  pressTypeCode: string;
}

export interface ShippingAdjustment {
  jobShippingItemSpecId: number;
  shipmentType: ShipmentTypeEnum;
  carrierType: CarrierTypeEnum;
  carrierService: string;
  // absent on offers made before the account could be chosen, and on the job adjust flow
  accountType?: ShippingAccountTypeEnum;
  /** what this shipment's freight costs, the basis revshop's shipping markup is measured on */
  charge?: number;
  estimatedShipTime: string;
  estimatedDeliveryTime: string;
}

// deliveryDateTime: string;

// shippingCost: number;
// shippingTotalCharge: number;

export interface RFMInvitation {
  id: number;
  jobId: number;
  opened: boolean;
  supplierOrgId: number;
  supplierOrgName: string;
  decision: RFMDecisionEnum;
  decisionUserId: number | null;
  decisionDate: string | null;
  expireAt: string;
  lastSentAt: string;
  createAt: string;
}

export enum RFMDecisionEnum {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  NONE = 'NONE',
}

export enum RFMPriorityEnum {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  NA = 'NA',
}

export interface RFMOfferParams {
  jobId: number;
  round: number;
  turnTimeDays: number | null;
  shippingPrice: number | null;
  supplierPrice: number | null;
  revshopMargin: number | null;
  expireAt: string;
  pressAdjustments: PressAdjustment[] | null;
  shippingAdjustments: ShippingAdjustment[] | null;
  invitedSupplierIds: number[] | null;
}

export enum RFMClosedStatusEnum {
  CANCELLED = 'CANCELLED',
  AWARDED = 'AWARDED',
  CLOSED = 'CLOSED',
}

export interface JobRFMClosed {
  rfmId: number;
  jobId: number;
  jobStatus: JobWorkflowStatusEnum | null;
  round: number;
  estimateTurnDays: number;
  estimatedShipTime: string | null;
  price: number;
  revshopMarkup: number;
  declinedCount: number;
  status: RFMClosedStatusEnum;
  closedAt: string | null;
  cancellationReason: string | null;
  awardedSupplierOrgId: number | null;
  awardedSupplierOrgName: string | null;
}

export interface RFMCancelParams {
  reason?: string | null;
}

export interface RFMSupplierOrg extends Organization {
  claimedRfmCount: number;
}

export interface SkuAvlPresses {
  avlPressTypes: AvlPressType[];
  skuId: number;
  skuName: string;
}

export interface AvlPressType {
  manufacturingTypeDescription: string;
  pressTypeCode: string;
  pressTypeDescription: string;
}

export interface JobSpecCarrierServices {
  jobShippingItemSpecId: number;
  carrierServices: CarrierServiceWithCharge[];
  accountTypes: ShippingAccountTypeOption[];
  /** the shipping the quote actually ran against */
  accountType: ShippingAccountTypeEnum | null;
  carrierService: string | null;
  shippingMethodAllowed: boolean;
}

export interface RFMShipmentSelection {
  jobShippingItemSpecId: number;
  accountType?: ShippingAccountTypeEnum;
}

export interface RFMShippingOptionsParams {
  pickupDate: string;
  selections?: RFMShipmentSelection[];
}

export interface ShippingAccountTypeOption {
  accountType: ShippingAccountTypeEnum;
  carrierTypes: CarrierTypeEnum[];
  orgId: number;
  orgName: string;
  company: string;
}

export interface CarrierServiceWithCharge {
  carrierService: string;
  carrierType: CarrierTypeEnum;
  deliveryDateTime: string;
  shipmentType: ShipmentTypeEnum;
  accountType: ShippingAccountTypeEnum;
  shippingAccount: string;
  businessDaysInTransit: string | null;
  dayOfWeek: string | null;
  estimatedShipTime: string | null;
  shippingCost: number;
  shippingTotalCharge: number;
  rush: boolean;
  tbd: boolean;
}

export type SpecIdToShippingMap = { [key: string]: CarrierServiceWithCharge };

export interface JobActivity {
  content: string;
  creatorFirstName: string;
  creatorLastName: string;
  eventTime: string;
  id: number;
  jobId: number;
  status: JobActivityStatus;
}

export enum JobActivityStatus {
  DATE_INVOICE_SENT,
  DATE_PAYMENT_RECEIVED,
  DATE_PAYMENT_SENT,
  DIGITAL_PROOF_UPLOADED,
  JOB_ACCEPTED,
  JOB_ACCEPTED_AND_PO_SENT,
  JOB_CONFIRMED_TO_SHIP_ONTIME,
  JOB_OPENED,
  JOB_STARTED,
  JOB_TICKET_OPENED,
  JOB_TO_RFM,
  PO_ACCEPTED,
  PO_DECLINED,
  PROOF_APPROVED,
  PROOF_AVAILABLE,
  PROOF_NOT_APPROVED,
  PROOF_SENT,
  PURCHASE_OCCURRED,
  SUPPLIER_ACCEPTS_JOB,
  TRACKING_ID_ENTERED_AND_DATE_SHIPPED,
}

export interface JobAdjustParams {
  jobId: number;
  shippingAdjustments: ShippingAdjustment[];
}

export enum PDF_TEMPLATE_ENUM {
  JOB_TICKET_REVSHOP = 'JOB_TICKET_REVSHOP',
  JOB_TICKET_SUPPLIER = 'JOB_TICKET_SUPPLIER',
  PACKING_SLIP_REVSHOP = 'PACKING_SLIP_REVSHOP',
  PACKING_SLIP_SUPPLIER = 'PACKING_SLIP_SUPPLIER',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  QUOTE = 'QUOTE',
  JOB_SUMMARY = 'JOB_SUMMARY',
}

export enum QUOTE_TYPE_ENUM {
  MY_QUOTE = 'MY_QUOTE',
  ORG_QUOTE = 'ORG_QUOTE',
  CUSTOMER_ORG_QUOTE = 'CUSTOMER_ORG_QUOTE',
}

export enum JobAdjustmentPrintingCategoryEnum {
  PAPER = 'PAPER',
  PRESS = 'PRESS',
  SERVICE = 'SERVICE',
  SERVICE_MATERIAL = 'SERVICE_MATERIAL',
  PARCEL = 'PARCEL',
  SHIPPING = 'SHIPPING',
  OTHER = 'OTHER',
}

export enum JobAdjustmentProcessStatusEnum {
  EDITING = 'EDITING',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  AWAITING_ACCEPT = 'AWAITING_ACCEPT',
  ACCEPTED = 'ACCEPTED',
  CANCELED = 'CANCELED',
  CLOSED_FOR_EDIT = 'CLOSED_FOR_EDIT',
}

export interface JobAdjustmentViewer {
  creatorId: number;
  customerId: number;
  jobId: number;
  orderId: number;
  jobName: number;
  createAt: string;
  updateAt: string;
  jobAdjustmentId: number;
  promoterRole: SiteRoleEnum | null;
  readyDate: string;
  costCenter: string;
  accountingLine: string;
  printing: JobAdjustmentPrintingViewer;
  printingItems: JobAdjustmentPrintingItemViewer[];
  shippingItems: JobAdjustmentShippingItemViewer[];
  originalTotal: JobAdjustmentTotalViewer;
  adjustTotal: JobAdjustmentTotalViewer;
  shipDateImpact: ShipDateImpactEnum;
  shipDateImpactAttachment: string;
  processStatus: JobAdjustmentProcessStatusEnum;
  sharedWiths: JobSharedWith[];
  isReadjust: boolean;
  supplierContacts: JobAdjustmentSupplierContact[];
  billingContact: string;
  costDistribution?: CostDistributionPayload;
  oracleBillingCode?: string;
}

export interface JobAdjustmentSupplierContact {
  email: string;
  firstName: string;
  lastName: string;
  selected: boolean;
  userId: number;
}

export interface JobCancellationViewer {
  id: number;
  cancellationFee: number;
  cancellationMarkup: number;
  cancellationMarkupPct: number;
  customerId: number;
  revisedJobCost: number;
  originalJobCost: number;
  tax: number;
  newCharges: number;
  customerInvoiceUrl: string;
  supplierChecked: boolean;
  buyerChecked: boolean;
  submitted: boolean;
  createAt: string;
  updateAt: string;
  promoterRole: SiteRoleEnum;
}

export interface JobCancellationParams {
  cancellationFee: number;
  cancellationMarkup: number;
  cancellationMarkupPct: number;
  revisedJobCost: number;
  originalJobCost: number;
  customerInvoiceUrl: string;
  supplierChecked: boolean;
  buyerChecked: boolean;
}

export interface JobAdjustmentPrintingViewer {
  skuId: number;
  skuName: string;
  size: string;
  /** Metric twin of `size`, sent alongside so a unit switch needs no refetch. */
  sizeMetric?: string;
  /** The ready-made size this job was configured with; shown only in its own unit. */
  sizePreset?: string;
  sizePresetUnit?: MeasurementUnitEnum;
  orientation: PaperOrientationEnum;
  parts: JobAdjustmentPrintingPartViewer[];
  services: string[];
  charge: number;
  quantity: number;
}

export interface JobAdjustmentPrintingPartViewer {
  paperName: string;
  pressName: string;
  inkFront: InkEnum;
  inkBack: InkEnum;
  pmsFront: string[];
  pmsBack: string[];
  skuTypeName: string;
  coatingFront: string;
  coatingBack: string;
  skuName: string;
}

export interface JobAdjustmentPrintingItemViewer {
  id: number;
  serialNumber: number;
  category: JobAdjustmentPrintingCategoryEnum;
  itemName: string;
  cost: number;
  markup: number;
  markupPct: number;
  totalCost: number;
  isTemp?: boolean;
  copyFromOldVersion?: boolean; // 标记是否为旧版本创建的项
}

export interface JobAdjustmentShippingItemViewer {
  shippingInfo: ShippingInfo;
  serialNumber: number;
  quantity: number;
  expectedDeliveryDate: string;
  readyDate: string;
  deliveryDate: string;
  price: number;
  cost: number;
  accountTypeSelects: AccountTypeSelects[];
  carrierServiceSelects: CarrierServiceSelects[];
  supplierShippingAccountCompanyName: string;
  orgShippingAccountCompanyName: string;
  copyFromOldVersion?: boolean;
}

export interface AccountTypeSelects {
  accountType: ShippingAccountTypeEnum;
  company: string;
  orgId: number;
  orgName: string;
}

export interface JobAdjustmentTotalViewer {
  printingCost: number;
  shippingCost: number;
  printingMarkup: number;
  printingMarkupPct: number;
  shippingMarkup: number;
  shippingMarkupPct: number;
  fees: JobAdjustmentFee[];
  tax: number;
  totalCharge: number;
  totalCost: number;
}

export interface JobAdjustmentFee {
  serialNumber?: number;
  fee?: number;
  description?: string;
}

export enum ShipDateImpactEnum {
  NONE = 'NONE',
  MANUFACTURING_DELAY = 'MANUFACTURING_DELAY',
  MATERIALS_DELAY = 'MATERIALS_DELAY',
  OTHER = 'OTHER',
}

export interface JobAdjustmentPrintingItemParams {
  id?: number;
  serialNumber: number;
  category?: JobAdjustmentPrintingCategoryEnum;
  itemName?: string;
  cost?: number;
  markup?: number;
  markupPct?: number;
  totalCost?: number;
}

export interface JobAdjustmentParams {
  costCenter?: string;
  accountingLine?: string;
  shippingMarkup?: number;
  shippingMarkupPct?: number;
  printingMarkup?: number;
  printingMarkupPct?: number;
  fees?: JobAdjustmentFee[];
  shipDateImpact?: ShipDateImpactEnum;
  shipDateImpactAttachment?: string;
  billingContact?: string;
  costDistribution?: CostDistributionPayload;
  oracleBillingCode?: string;
}

export interface JobAdjustmentShippingItemParams {
  serialNumber: number;
  price?: number;
  accountType?: ShippingAccountTypeEnum;
  shipmentType?: ShipmentTypeEnum;
  carrierType?: CarrierTypeEnum;
  carrierService?: string;
  deliveryDate?: string;
}

export interface JobAdjustmentSharedWithParams {
  firstName: string;
  lastName: string;
  email: string;
}

export interface JobListFilterParams {
  prefix: string;
  limit: number;
  filterType: JobWorkspaceFilterTypeEnum;
  statusFilter?: JobUIStatusEnum | JobWorkflowStatusEnum;
  searchGroup?: OrderHistorySearchGroupEnum;
  statusFilterSeparateTab?: JobStatusFilterSeparateTabEnum;
  excludeProjectId?: number;
}


export interface RFQListFilterParams {
  prefix: string;
  limit: number;
  startDate?: string;
  endDate?: string;
  supplierOrgIds?: number[];
  status?: RFQOrgStatusEnum[];
}

export interface SimpleJobRevision {
  id: number;
  jobId: number;
  revisionNumber: number;
  revisionJobId: string;
  name: string;
  jobConfigId: string;
  createAt: string;
  orderDate: string;
}

export interface JobWorkspaceGroup {
  jobs: JobItem[];
  orderId: string;
  jobCardShippingItem: ShippingInfo;
  workflowStatus: JobWorkflowStatusEnum;
  jobType: JobTypeEnum;
}

export enum JobStatusFilterSeparateTabEnum {
  STANDARD_JOBS = 'STANDARD_JOBS',
  PRE_CONFIGURED_SKU = 'PRE_CONFIGURED_SKU',
  ARCHIVED_INVOICES = 'ARCHIVED_INVOICES',
  PRE_CONFIGURED_SKU_ARCHIVED_INVOICES = 'PRE_CONFIGURED_SKU_ARCHIVED_INVOICES',
}

export enum MultiplePDFMergeTypeEnum {
  MERGE_TO_ONE_PDF = 'MERGE_TO_ONE_PDF',
  MERGE_TO_ZIP = 'MERGE_TO_ZIP',
}

export interface BatchJobMergePDFParams {
  jobIds: string;
  mergeType: MultiplePDFMergeTypeEnum;
  template: PDF_TEMPLATE_ENUM;
}

export interface BatchJobCompleteParams {
  items: {
    jobId: number;
  }[];
}

export enum JobWorkspaceFilterTypeEnum {
  JOB_WORKSPACE = 'JOB_WORKSPACE',
  ORDER_HISTORY = 'ORDER_HISTORY',
  PROJECT_JOB_FILTER = 'PROJECT_JOB_FILTER',
  JOB_ARCHIVE = 'JOB_ARCHIVE',
}

export interface Company {
  id?: number;
  name?: string;
  createAt?: string;
  updateAt?: string;
  version?: number;
}

export interface JobCustomerOrgInfoDTO {
  id?: number;
  parentId?: number;
  name?: string;
  logo?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  phone1?: string;
  phone2?: string;
  fax?: string;
  company?: Company;
}

export interface JobWorkspaceDTO {
  jobId: number;
  revisionNumber: number;
  jobName: string;
  jobType: JobTypeEnum;
  orderId: string;
  generateType: JobGenerateTypeEnum;
  configGenerateType: JobConfigGenerateTypeEnum;
  skuId: number;
  quantity: number;
  skuName: string;
  finishedSize: string;
  image: string;
  sellPrice: number;
  workflowStatus: JobWorkflowStatusEnum;
  frozenWorkflowStatus: JobWorkflowStatusEnum;
  adjustmentStatus: JobAdjustmentStatusEnum;
  cancellationStatus: JobCancellationStatusEnum;
  invoiceStatus: InvoiceStatusEnum;
  artworkConfirm: boolean;
  archived: boolean;
  skipArtFile: boolean;
  fromUnitPriceSku: boolean;
  directlyAddToCart: boolean;
  projectId: number;
  projectName: string;
  customerId: number;
  customerOrgId: number;
  supplierOrgId: number;
  originalQuoteOrgId: number;
  jobCustomerOrgInfoDTO?: JobCustomerOrgInfoDTO;
  contactInfo: WorkspaceContactInfoDTO;
  shippingItems: JobAdjustmentShippingItemViewer[];
  billingRequestor: BillingRequestor;
  billingInfo: BillingInfo;
  invoice: JobInvoice;
  po: JobPoData;
  jobSharedWiths: JobSharedWith[];
  tabCounts: WorkspaceTabCountsDTO;
  createAt: string;
  updateAt: string;
  statusChangeAt: string;
  expectPaymentBy: string;
  ticketDownloaded: boolean;
  jobFilesEditable: boolean;
  jobFilesDownloaded: boolean;
  participants: JobParticipantEnum[];
  cardType: WorkspaceCardTypeEnum;
  manualOverrideReadyDate: boolean | null;
}

export interface QuoteWorkspaceDTO {
  quoteId: string;
  quoteName: string;
  jobType: JobTypeEnum;
  generateType: JobGenerateTypeEnum;
  configGenerateType: JobConfigGenerateTypeEnum;
  projectId: number;
  projectName: string;
  skuId: number;
  quantity: number;
  skuName: string;
  finishedSize: string;
  image: string;
  customerId: number;
  customerOrgId: number;
  contactInfo: WorkspaceContactInfoDTO;
  shippingItems: JobAdjustmentShippingItemViewer[];
  jobSharedWiths: JobSharedWith[];
  quantityItems: QuantityItem[];
  filesCount: number;
  createAt: string;
  updateAt: string;
  canEdit: boolean;
  isRevising: boolean;
  isProxied: boolean;
  canAddToCart: boolean;
  artworkConfirm: boolean;
  jobFilesEditable: boolean;
  priceGuaranteeHours: number;
  cardType: WorkspaceCardTypeEnum;
}

export interface RfmClaimWorkspaceDTO {
  rfmId: number;
  jobId: number;
  jobType: string;
  quantity: number;
  estimateTurnDays: number;
  estimatedShipTime: string;
  supplierPrice: number;
  shippingPrice: number;
  createAt: string;
  expiredAt: string;
  cardType: WorkspaceCardTypeEnum;
}

export interface RfmWorkspaceDTO {
  rfmId: number;
  jobId: number;
  jobType: string;
  estimateTurnDays: number;
  estimatedShipTime: string;
  price: number;
  revshopMarkup: number;
  declinedCount: number;
  expiredAt: string;
  cardType: WorkspaceCardTypeEnum;
}

export interface RfqClaimWorkspaceDTO {
  id: number;
  rfqOrgStatus: RFQOrgStatusEnum;
  projectName: string;
  qtyItems: QtyItem[];
  sendAt: string;
  awardedAt: string;
  declineAt: string;
  responseAt: string;
  responseBy: string;
  rush: boolean;
  cardType: WorkspaceCardTypeEnum;
}

export interface RfqWorkspaceDTO {
  rfqId: number;
  rfqName: string;
  rfqStatus: RFQStatusEnum;
  rush: boolean;
  skuId: number;
  skuName: string;
  finishedSize: string;
  image: string;
  jobSharedWiths: JobSharedWith[];
  skipArtFile: boolean;
  customerId: number;
  customerOrgId: number;
  contactInfo: WorkspaceContactInfoDTO;
  qtyItemRequirements: QtyItemRequirement[];
  filesCount: number;
  createAt: string;
  updateAt: string;
  jobFilesEditable: boolean;
  cardType: WorkspaceCardTypeEnum;
  copyFromId: number | null;
  canCopyRfq: boolean | null;
}

export interface QtyItem {
  id: number;
  estimateTurnaroundDays: number;
  qtySerialNumber: number;
  quantity: number;
  readyDate: string;
  deliveryDate: string;
  shippingVarious: boolean;
}

export interface WorkspaceContactInfoDTO {
  customerOrg: JobCardOrg;
  supplierOrg: JobCardOrg;
  createBy: UserContactAddress;
  supplierContacts: UserContactAddress[];
  revshopContactsLabel: string;
  revshopContacts: UserContactAddress[];
}

export interface WorkspaceTabCountsDTO {
  notesCount: number;
  activityCount: number;
  filesCount: number;
  proofsCount: number;
  rfmOfferCount: number;
}

export interface QuickBooksCheckLoginResponse {
  hasLogin: boolean;
  loginUrl?: string;
  csrfToken?: string;
}

export interface RefreshQuickBooksTokenResponse {
  hasLinkQuickBooks: boolean;
  tokenExpired: boolean;
  loginUrl?: string;
  csrfToken?: string;
}

export interface JobWorkspaceParams {
  filterType: JobWorkspaceFilterTypeEnum;
  statusFilter: JobWorkflowStatusEnum;
  statusFilterSeparateTab: JobStatusFilterSeparateTabEnum;
  jobOrOrderNumber: string;
  jobName: string;
  supplierName: string;
  requesterName: string;
  excludeProjectId: number;
  jobDoc: string;
  workflowStatus: JobWorkflowStatusEnum;
  startOrderDate: string;
  endOrderDate: string;
  startDeliveryDate: string;
  endDeliveryDate: string;
}

export enum WorkspaceCardTypeEnum {
  JOB = 'JOB',
  QUOTE = 'QUOTE',
  RFQ = 'RFQ',
  RFQ_CLAIM = 'RFQ_CLAIM',
  RFM = 'RFM',
  RFM_CLAIM = 'RFM_CLAIM',
}
